import React, {createContext, useContext, useEffect, useState} from 'react';
import {useZooPassAppContext} from "../../Context/ZooPassAppContext";
import {IZooPassAnswersContext, useZooPassAppAnswersContext, ZooPassAppAnswersContext} from "../../Context/ZooPassAnswersContext";
import {StepTitleContent} from "../PanelContents/StepTitleContent";
import {ImageAnswerComponent} from "../PanelContents/ImageAnswer";
import ZooPassLocalStateUtility from "../../Utilities/ZooPassLocalStateUtility";

export const Step7SidebarValue : React.FC = () => {

    let {
        zooPassMembership,
        loading
    } = useZooPassAppContext();

    let {
        answersData,
        answersLoading
    } = useZooPassAppAnswersContext();
    
    const [text, setText] = useState<string>();
    
    useEffect(() => {
        if(loading || answersLoading || answersData == null) {
            setText("");
            return;
        }
        if(answersData.step7Value == null) {
            setText("");
            return;
        }
        const membership = zooPassMembership.get(answersData.step7Value);
        if(membership == null) {
            setText("");
            
            return;
        }
        setText(membership.title);
    }, [answersData?.step7Value, loading, answersLoading]);
    
    return(<><span>{text}</span></>);
};

